"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONShapeConverter = void 0;
var shape_1 = require("../../shapes/shape");
var json_floating_enums_1 = require("../enums/json-floating-enums");
var JSONShapeConverter = (function () {
    function JSONShapeConverter() {
    }
    JSONShapeConverter.convertFromJSON = function (obj) {
        var result = new shape_1.Shape();
        result.fillColor = obj[json_floating_enums_1.JSONShapeProperty.FillColor];
        result.outlineColor = obj[json_floating_enums_1.JSONShapeProperty.OutlineColor];
        result.outlineWidth = obj[json_floating_enums_1.JSONShapeProperty.OutlineWidth];
        return result;
    };
    JSONShapeConverter.convertToJSON = function (source) {
        var result = {};
        result[json_floating_enums_1.JSONShapeProperty.FillColor] = source.fillColor;
        result[json_floating_enums_1.JSONShapeProperty.OutlineColor] = source.outlineColor;
        result[json_floating_enums_1.JSONShapeProperty.OutlineWidth] = source.outlineWidth;
        return result;
    };
    return JSONShapeConverter;
}());
exports.JSONShapeConverter = JSONShapeConverter;
